import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ButtonModule,
  DrawerModule,
  UiModule,
} from '@lockton-apps/shared/ui/lui';
import { MatIconModule } from '@angular/material/icon';
import { MaterialModule } from '@lockton-apps/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  DevConfig,
  DevConfigClient,
  DevConfigProposalForm,
  DevConfigQuote,
  getDevConfig,
  setDevConfig,
} from '@lockton-apps/shared/util/helpers';
import { DynamicFormsModule } from '@lockton-apps/dynamic-forms';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { QUOTE_PERMISSIONS } from '@lockton-apps/shared/interfaces';
import { map } from 'lodash';

interface FormModel {
  proposalForm: DevConfigProposalForm;
  quote: DevConfigQuote;
  client: DevConfigClient;
}

@Component({
  selector: 'la-dev-panel',
  imports: [
    CommonModule,
    ButtonModule,
    DrawerModule,
    MatIconModule,
    UiModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    DynamicFormsModule,
  ],
  templateUrl: './dev-panel.component.html',
  styleUrls: ['./dev-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DevPanelComponent implements OnInit {
  fields!: FormlyFieldConfig[];

  ngOnInit(): void {
    this.initializeModel(getDevConfig());
  }

  private initializeModel(config: DevConfig) {
    this.fields = [
      {
        key: 'proposalForm',
        fieldGroup: [
          {
            template: 'Proposal',
            className: 'mat-h4 d-inline-block mb-2',
          },
          {
            key: 'runLocally',
            type: 'checkbox',
            defaultValue: config.proposalForm.runLocally,
            className: 'd-block',
            props: {
              label: 'Run locally',
            },
          },
          {
            fieldGroup: [
              {
                key: 'mockData',
                type: 'checkbox',
                defaultValue: config.proposalForm.mockData,
                className: 'd-block',
                props: {
                  label: 'Use local data',
                },
              },
            ],
            expressions: {
              hide: '!model.runLocally',
            },
          },
        ],
      },
      {
        type: 'divider',
        className: 'd-block my-2',
      },
      {
        key: 'quote',
        fieldGroup: [
          {
            template: 'Quote',
            className: 'mat-h4 d-inline-block mb-2',
          },
          {
            key: 'permissions',
            type: 'chips-autocomplete',
            defaultValue: config.quote.permissions,
            className: 'd-block mt-1',
            props: {
              label: 'Permissions',
              options: map(QUOTE_PERMISSIONS, (value) => ({
                value,
                label: value,
              })),
              tooltip: {
                text: 'Within prop form it works only when the prop runs locally.',
              },
            },
          },
        ],
      },
      {
        type: 'divider',
        className: 'd-block my-2',
      },
      {
        key: 'client',
        fieldGroup: [
          {
            template: 'Client',
            className: 'mat-h4 d-inline-block mb-2',
          },
          {
            key: 'fullMock',
            type: 'checkbox',
            defaultValue: config.client.fullMock,
            className: 'd-block',
            props: {
              label: 'Full mock (client, contacts, folders)',
            },
          },
        ],
      },
    ];
  }

  onSubmit(value: FormModel): void {
    setDevConfig(value);
  }
}
